export default __webpack_public_path__ + "static/media/invest_simulation.fd8c3f2c.gif";